import getStore from '../data/store/store';
/**
 * Util to get calendar processing options from store
 */
export default function getCalendarOptions() {
    return getStore().calendarProcessingOptions;
}
//# sourceMappingURL=getCalendarOptions.js.map